<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerService from '@/services/customer'

export default {
  page: {
    title: "Representantes",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Representantes",
      agents: [], 
      fields: [
        { key: 'name', label: 'Nome' },
        { key: 'document_number', label: 'CPF' },
        { key: 'phone_number', label: 'Telefone' },
        { key: 'email', label: 'E-mail' },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: 'Ações' },
      ],
      searchValue: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    }
  },
  computed: {
    rows() {
      return this.agents.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page) {
      let loader = this.$loading.show();

      CustomerService.getAgents(page, this.searchValue).then(res => {
        loader.hide();

        this.agents = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    search() {
      this.load(1);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCustomers(true, 1, this.searchValue);
      }
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por nome..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <router-link to="/agents/edit">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2">
                      <i class="mdi mdi-plus mr-1"></i> Novo Representante
                    </button>
                  </router-link>
                </div>
              </div>
              <!-- end col-->
            </div>
            <!-- Table data -->
            
            <div class="table-responsive mb-0 align-middle">
              <b-table
                align="center"
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="agents"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(status)="row">
                  <!-- <span class="badge badge-pill badge-soft-primary font-size-12">Pendente</span> -->

                  <span
                    class="badge badge-pill badge-soft-primary font-size-12"
                    :class=" {
                      'badge-soft-success': row.item.hasUser === true,
                      'badge-soft-primary': row.item.hasUser === false,
                    }"
                  >{{row.item.hasUser ? 'Cadastrado' : 'Pendente'}}</span>
                </template>

                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" dropleft toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>
                    <router-link :to="'/agents/edit/' + row.item._id">
                      <b-dropdown-item href="javascript: void(0);">
                        <i class="fas fa-edit text-warning mr-2 mt-2"></i>
                        Editar
                      </b-dropdown-item>
                    </router-link>
                    <!-- <b-dropdown-item v-b-modal.modal-remove>
                      <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i>
                      Inativar
                    </b-dropdown-item> -->
                  </b-dropdown>
                </template>
              </b-table>
            </div>


            <div class="row justify-content-md-between align-items-md-center">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
              <!-- end col-->
              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
              <!-- end col-->
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }

  .table td {
    vertical-align: middle;
  }
</style>